// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   DASHBOARD COMPACT - NOUVEAU DESIGN
   ============================================ */

.db-compact {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    font-size: 11px;
    max-height: 200px;
}

/* L'EN-TÊTE A ÉTÉ RETIRÉ AU LOT 5.5, avec \`.db-header\`, \`.db-title\`,
   \`.db-header-actions\` et \`.db-btn\`. Ses deux appelants le masquaient déjà : la
   modale par \`insideModal\`, et la zone haute du Calendrier parce que la maquette
   met ces boutons dans l'en-tête de la CARTE qui entoure le tableau. C'est lui
   qui portait les deux derniers \`⬜\` du module. */

/* ── Corps scrollable ── */
.db-body {
    overflow-y: auto;
    flex: 1 1;
    padding: 4px;
}

.db-empty {
    text-align: center;
    color: #64748b;
    padding: 16px;
}

/* ── Bloc niveau ── */
.db-niveau-block {
    margin-bottom: 6px;
    border: 1px solid #e2e8f0;
    border-radius: 5px;
    overflow: hidden;
}

.db-niveau-header {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 5px 8px;
    background: #1e40af;
    color: white;
    cursor: pointer;
    user-select: none;
    font-weight: 600;
    font-size: 11px;
    transition: background 0.15s;
}

.db-niveau-header:hover {
    background: #1e3a8a;
}

.db-toggle {
    font-size: 9px;
    opacity: 0.8;
}

.db-niveau-title {
    font-size: 12px;
}

.db-niveau-subtitle {
    font-size: 10px;
    opacity: 0.75;
    font-weight: 400;
}

/* ── Tableau ── */
.db-table-scroll {
    overflow-x: auto;
}

.db-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 10px;
    table-layout: fixed;
}

/* Largeurs des colonnes */
.db-th-label    { width: 90px; text-align: left; }
.db-th-annee    { width: 100px; }
.db-th-sem      { width: 90px; }
.db-th-sub      { font-size: 8px; font-weight: 500; }

.db-table thead tr th {
    background: #f1f5f9;
    color: #475569;
    font-weight: 600;
    padding: 3px 4px;
    border: 1px solid #e2e8f0;
    text-align: center;
    white-space: nowrap;
}

.db-thead-top th { border-bottom: none; }
.db-thead-sub th { border-top: none; background: #f8fafc; }

/* ── Cellules de données ── */
.db-table td {
    padding: 2px 4px;
    border: 1px solid #f1f5f9;
    text-align: center;
    white-space: nowrap;
}

.db-td-type {
    text-align: left;
    font-weight: 500;
    color: #334155;
    padding-left: 6px;
    font-size: 9px;
    background: #fafafa;
}

.db-td-groupe {
    text-align: left;
    color: #475569;
    font-size: 9px;
    padding-left: 4px;
    background: #fafafa;
}

.db-td-obj {
    color: #64748b;
    font-size: 9px;
}

.db-td-num {
    color: #475569;
    font-size: 9px;
}

.db-dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    margin-right: 3px;
    vertical-align: middle;
    flex-shrink: 0;
}

/* ── Statut réel vs objectif ── */
.db-val {
    font-weight: 600;
    font-size: 9px;
}

.db-ok {
    color: #16a34a;
}

.db-exceed {
    color: #dc2626;
}

.db-neutral {
    color: #94a3b8;
}

/* ── Séparateur entre groupes ── */
.db-tr-last td {
    border-bottom: 2px solid #cbd5e1;
}

/* ── Ligne total niveau ── */
.db-tr-total td {
    background: #eff6ff;
    border-top: 1px solid #bfdbfe;
}

.db-total-label {
    font-weight: 600 !important;
    color: #1e40af !important;
    font-size: 9px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,iBAAiB;AACrB;;AAEA;;;;iDAIiD;;AAEjD,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B,kBAAkB,WAAW,EAAE,gBAAgB,EAAE;AACjD,kBAAkB,YAAY,EAAE;AAChC,kBAAkB,WAAW,EAAE;AAC/B,kBAAkB,cAAc,EAAE,gBAAgB,EAAE;;AAEpD;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,mBAAmB,mBAAmB,EAAE;AACxC,mBAAmB,gBAAgB,EAAE,mBAAmB,EAAE;;AAE1D,8BAA8B;AAC9B;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;;AAEA,kCAAkC;AAClC;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,mCAAmC;AACnC;IACI,gCAAgC;AACpC;;AAEA,6BAA6B;AAC7B;IACI,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,cAAc;AAClB","sourcesContent":["/* ============================================\n   DASHBOARD COMPACT - NOUVEAU DESIGN\n   ============================================ */\n\n.db-compact {\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    font-size: 11px;\n    max-height: 200px;\n}\n\n/* L'EN-TÊTE A ÉTÉ RETIRÉ AU LOT 5.5, avec `.db-header`, `.db-title`,\n   `.db-header-actions` et `.db-btn`. Ses deux appelants le masquaient déjà : la\n   modale par `insideModal`, et la zone haute du Calendrier parce que la maquette\n   met ces boutons dans l'en-tête de la CARTE qui entoure le tableau. C'est lui\n   qui portait les deux derniers `⬜` du module. */\n\n/* ── Corps scrollable ── */\n.db-body {\n    overflow-y: auto;\n    flex: 1;\n    padding: 4px;\n}\n\n.db-empty {\n    text-align: center;\n    color: #64748b;\n    padding: 16px;\n}\n\n/* ── Bloc niveau ── */\n.db-niveau-block {\n    margin-bottom: 6px;\n    border: 1px solid #e2e8f0;\n    border-radius: 5px;\n    overflow: hidden;\n}\n\n.db-niveau-header {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 5px 8px;\n    background: #1e40af;\n    color: white;\n    cursor: pointer;\n    user-select: none;\n    font-weight: 600;\n    font-size: 11px;\n    transition: background 0.15s;\n}\n\n.db-niveau-header:hover {\n    background: #1e3a8a;\n}\n\n.db-toggle {\n    font-size: 9px;\n    opacity: 0.8;\n}\n\n.db-niveau-title {\n    font-size: 12px;\n}\n\n.db-niveau-subtitle {\n    font-size: 10px;\n    opacity: 0.75;\n    font-weight: 400;\n}\n\n/* ── Tableau ── */\n.db-table-scroll {\n    overflow-x: auto;\n}\n\n.db-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 10px;\n    table-layout: fixed;\n}\n\n/* Largeurs des colonnes */\n.db-th-label    { width: 90px; text-align: left; }\n.db-th-annee    { width: 100px; }\n.db-th-sem      { width: 90px; }\n.db-th-sub      { font-size: 8px; font-weight: 500; }\n\n.db-table thead tr th {\n    background: #f1f5f9;\n    color: #475569;\n    font-weight: 600;\n    padding: 3px 4px;\n    border: 1px solid #e2e8f0;\n    text-align: center;\n    white-space: nowrap;\n}\n\n.db-thead-top th { border-bottom: none; }\n.db-thead-sub th { border-top: none; background: #f8fafc; }\n\n/* ── Cellules de données ── */\n.db-table td {\n    padding: 2px 4px;\n    border: 1px solid #f1f5f9;\n    text-align: center;\n    white-space: nowrap;\n}\n\n.db-td-type {\n    text-align: left;\n    font-weight: 500;\n    color: #334155;\n    padding-left: 6px;\n    font-size: 9px;\n    background: #fafafa;\n}\n\n.db-td-groupe {\n    text-align: left;\n    color: #475569;\n    font-size: 9px;\n    padding-left: 4px;\n    background: #fafafa;\n}\n\n.db-td-obj {\n    color: #64748b;\n    font-size: 9px;\n}\n\n.db-td-num {\n    color: #475569;\n    font-size: 9px;\n}\n\n.db-dot {\n    display: inline-block;\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    margin-right: 3px;\n    vertical-align: middle;\n    flex-shrink: 0;\n}\n\n/* ── Statut réel vs objectif ── */\n.db-val {\n    font-weight: 600;\n    font-size: 9px;\n}\n\n.db-ok {\n    color: #16a34a;\n}\n\n.db-exceed {\n    color: #dc2626;\n}\n\n.db-neutral {\n    color: #94a3b8;\n}\n\n/* ── Séparateur entre groupes ── */\n.db-tr-last td {\n    border-bottom: 2px solid #cbd5e1;\n}\n\n/* ── Ligne total niveau ── */\n.db-tr-total td {\n    background: #eff6ff;\n    border-top: 1px solid #bfdbfe;\n}\n\n.db-total-label {\n    font-weight: 600 !important;\n    color: #1e40af !important;\n    font-size: 9px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
